import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';
// const images = [
//     { imageUrl: "/img/test/4.png", name: "Nexus", userImage: "/img/favicon.png", title: "Coming Soon!", discription: "Our website is under construction. Stay tuned for the launch!" },
//     { imageUrl: "/img/test/6.jpeg", name: "Nexus", userImage: "/img/favicon.png" },
//     { imageUrl: "/img/test/5.jpeg", name: "Nexus", userImage: "/img/favicon.png" }
//   ];
const Carousel = () => {
  const [images, setImages] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const [startPosition, setStartPosition] = useState(0);
  const [draggedDistance, setDraggedDistance] = useState(0);
  const carouselRef = useRef(null);
  const autoplayRef = useRef(null);
  // Array of images for the carousel
  
  // "/carousel/item"
  useEffect(() => {
    const fetchItems = async () => {
      try {
        const response = await axios.get(process.env.REACT_APP_API_URL + '/carousel/item', { withCredentials: true });
        setImages(response.data);
      } catch (error) {
        console.error('Error fetching items:', error);
      }
    };
    fetchItems();
  }, []);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  // Next and Prev Slide functions
  
  useEffect(() => {
    if (isDragging) return;
    autoplayRef.current = setInterval(() => {
      nextSlide();
    }, 3000);
    return () => clearInterval(autoplayRef.current);
  }, [images]);

  
  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
  };

  const handleDragStart = (e) => {
    setIsDragging(true);
    const position = e.type === 'mousedown' ? e.clientX : e.touches[0].clientX;
    setStartPosition(position);
    carouselRef.current.style.transition = 'none'; // Disable transition while dragging
    document.body.style.cursor = 'grabbing'; // Change cursor to grabbing while dragging
  };

  // Handle the drag (mousemove or touchmove)
  const handleDrag = (e) => {
    if (!isDragging) return;
    const position = e.type === 'mousemove' ? e.clientX : e.touches[0].clientX;
    setDraggedDistance(position - startPosition);
  };

  // Handle the drag end (mouseup or touchend)
  const handleDragEnd = () => {
    if (!isDragging) return;
    const direction = draggedDistance > 0 ? -1 : 1; // Determine swipe direction
    if (Math.abs(draggedDistance) > 100) { // If dragged enough, switch slide
      setCurrentIndex((prevIndex) => (prevIndex + direction + images.length) % images.length);
    }
    setIsDragging(false);
    setDraggedDistance(0);
    carouselRef.current.style.transition = 'transform 0.5s ease-in-out'; // Re-enable transition
    document.body.style.cursor = 'grab'; // Reset cursor to grab when not dragging
  };

  // Update the translateX of the carousel based on dragged distance
  const translateX = -(currentIndex * 100) + (draggedDistance / window.innerWidth) * 100;
if (!images || images.length === 0){
return (
  <div className='my-2'>
  <div
    className="carousel-container relative w-full max-w-lg mx-auto"
  >
    {/* Carousel wrapper with sliding effect */}
    <div className="carousel-images relative w-full h-64 overflow-hidden rounded-lg">
    <div className="skeleton">
      </div></div>
  </div>
  <div className='flex justify-center'>
        <div className='flex gap-1 mt-2'>
          <div
              className={`carousel-indicator w-2 h-2 rounded-full cursor-pointer bg-white`}
            />
         <div
              className={`carousel-indicator w-2 h-2 rounded-full cursor-pointer bg-gray-300`}
            />
            <div
              className={`carousel-indicator w-2 h-2 rounded-full cursor-pointer bg-gray-300`}
            />
        </div>
      </div>
</div>
)
};
  return (
    <div className='my-2'>
      <div
        className="carousel-container relative w-full mx-auto"
        onMouseDown={handleDragStart}
        onTouchStart={handleDragStart}
        onMouseMove={handleDrag}
        onTouchMove={handleDrag}
        onMouseUp={handleDragEnd}
        onTouchEnd={handleDragEnd}
        onMouseLeave={handleDragEnd} // Optional: to handle case if the user leaves the component while dragging
        style={{ cursor: isDragging ? 'grabbing' : 'grab' }} // Change cursor on drag
      >
        {/* Carousel wrapper with sliding effect */}
        <div className="carousel-images relative w-full h-64 md:h-96 overflow-hidden rounded-lg">
          <div
            className="carousel-wrapper flex w-full h-full transition-transform duration-500 ease-in-out"
            ref={carouselRef}
            style={{ transform: `translateX(${translateX}%)` }}
          >

            {images.map((image, index) => (
              <div
                key={index}
                className="carousel-item w-full h-full flex-shrink-0 bg-cover bg-center"
                style={{
                  backgroundImage: `url("${image.imageUrl}")`,
                }}
              >
                <div className='py-3 pl-3 flex items-center gap-1'><span className='bg-white py-1 px-1 p text-[10px] flex items-center rounded-full'><img className='h-3 opacity-50' src='/img/camera.svg' /></span><a className='bg-white py-0.5 pl-1 pr-2 font-semibold text-[10px] text-gray-600 flex items-center rounded-full gap-1 cursor-pointer'><img className='h-3 rounded-full' src={image.userImage} />{image.name}</a></div>
                {/* <div className='absolute bottom-0 left-0 w-full p-2 bg-gradient-to-t from-slate-800/90 to-transparent'><h1 className='mt-2 mb-4 text-white text-sm font-semibold'>{image.title}</h1></div> */}
                {(image.title || image.discription) && (<div className='absolute bottom-0 w-full p-3 bg-gradient-to-t from-slate-800/90 to-transparent'>
                  {image.title && (<span className='bg-white/70 backdrop-invert backdrop-opacity-95 py-1 px-2 rounded-lg overflow-hidden font-semibold text-xs text-gray-700'>
                    {image.title}
                  </span>)}
                  {image.discription && (<p className='text-xs text-white mr-8 my-2'>{image.discription}</p>)}
                </div>)}
                {/* <div class="bg-white/30 backdrop-invert backdrop-opacity-10 ..."></div> */}
              </div>
            ))}
          </div>
        </div>

        {/* Next and Prev buttons */}
        <button
          onClick={prevSlide}
          className="opacity-20 prev-button absolute top-1/2 left-2 transform -translate-y-1/2 bg-white text-black p-2 rounded-full"
        >
          <svg
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M15 19l-7-7 7-7"
            />
          </svg>      </button>
        <button
          onClick={nextSlide}
          className="opacity-20 next-button absolute top-1/2 right-2 transform -translate-y-1/2 bg-white text-black p-2 rounded-full"
        >
          <svg
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M9 19l7-7-7-7"
            />
          </svg>
        </button>
      </div>
      <div className='flex justify-center'>
        <div className='flex gap-1 mt-2'>
          {images.map((_, index) => (
            <div
              key={index}
              onClick={() => setCurrentIndex(index)}
              className={`carousel-indicator w-2 h-2 rounded-full cursor-pointer ${index === currentIndex ? 'bg-white' : 'bg-gray-300'
                }`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Carousel;
